// -------------------------------------
// Externe Theme-Utilities
// -------------------------------------
import { stickyBox } from "../../node_modules/cronus-theme/default/global/js/stickyBox";
import { initJumpmarks } from "../../node_modules/cronus-theme/default/global/js/jumpmark";
import { Tooltip } from "../../node_modules/cronus-theme/default/global/js/tooltip";
import { initScrolltopbutton } from "../../node_modules/cronus-theme/default/global/js/scrolltop";
import hoverintent from "../../node_modules/cronus-theme/default/global/js/hoverintent";

// -------------------------------------
// Lokale Module
// -------------------------------------
import {
    initWeeklyScrollbar,
    initWeeklyScrollbarLogin,
    toggleClass,
    printWeekly,
    initWeeklyNav,
    initQuickSearch,
    setupWeeklyLazyInjection,
    interceptWindowPrint,
    initDropdowns,
    initFilters,
    setLicenseExpiresSoonCookie,
    sortItems,
    initIntro,
    resetIntro
} from "./collections/weekly";
import {
    initSortSelectWeekly,
    sortItemsByUrl,
    initBundleScrollbar,
    applySortingToGroupItems
} from "./collections/bundle";
import { initKeycloakAuth } from "./keycloakAuth";
import { initCollectionShare } from "./share";
import { initSharedLinks } from "./sharedLinks";

// -------------------------------------
// Initialisierung nach vollständigem DOM-Laden
// -------------------------------------
document.addEventListener("DOMContentLoaded", function () {
    // Zentrale DOM-Referenzen
    const stickyHeaderArea = document.querySelector(".headerMain");
    const hasFilters = document.querySelector(".filters") && document.querySelector(".filter");
    const hasItems = document.getElementById("items") && document.querySelector("#items .item");
    const hasActiveFilters = document.getElementById("active-filters");

    // ---------------------------------
    // Basis-Features initialisieren
    // ---------------------------------
    initKeycloakAuth();
    initCollectionShare();
    initSharedLinks();
    initScrolltopbutton();

    // Weekly-/Collection-Funktionen initialisieren
    initWeeklyScrollbar(document.querySelectorAll(".weeklyList>.container>.swiper"));
    initBundleScrollbar(document.querySelectorAll(".bundleList>.container>.swiper"));
    initWeeklyScrollbarLogin(document.querySelectorAll(".collection.preview.login .swiper"));
    initWeeklyNav();
    initQuickSearch();
    setupWeeklyLazyInjection(document);

    // ---------------------------------
    // Optionale UI-Funktionen
    // ---------------------------------

    // Hover-Intent nur aktivieren, wenn Such-Trigger vorhanden ist
    const toggleSearch = document.querySelector(".js-toggleSearch");
    if (toggleSearch) {
        hoverintent(toggleSearch, 0);
    }

    if (toggleSearch) {
        document.querySelector('.js-toggleSearch').addEventListener('mouseenter', () => {
            document.querySelector('form.searchBar input').focus();
        });
    }

    // Tooltips für alle passenden Elemente initialisieren
    document.querySelectorAll('[data-toggle="tooltip"]').forEach((el) => {
        Tooltip.getOrCreateInstance(el, {});
    });

    // ---------------------------------
    // Sticky-Elemente konfigurieren
    // ---------------------------------
    let offsetTopStickyBox = 30;

    // Höhe des Sticky-Headers auf den Offset addieren,
    // damit sticky Elemente nicht unter dem Header verschwinden
    if (stickyHeaderArea) {
        offsetTopStickyBox += stickyHeaderArea.clientHeight;
    }

    // Alle Sticky-Boxen initialisieren
    document.querySelectorAll(".js-stickyBoxWeekly").forEach((pinBox) => {
        stickyBox(pinBox, {
            selectorPinArea: ".js-stickyAreaWeekly",
            minWidth: GLOBALS.gridBreakpoints.lg,
            offsetTop: offsetTopStickyBox
        });
    });

    // ---------------------------------
    // Event-Handler registrieren
    // ---------------------------------

    // Audio-/Detailbereiche per CSS-Klasse ein-/ausblenden
    document.querySelectorAll(".js-toggleAudio").forEach((el) => {
        el.addEventListener("click", function () {
            toggleClass(document.getElementById(el.dataset.id), "is-active");
        });
    });

    // Weekly-Druckfunktion
    document.querySelectorAll(".js-printWeekly").forEach((el) => {
        el.addEventListener("click", function () {
            printWeekly();
        });
    });

    // Globales Print-Verhalten anpassen
    interceptWindowPrint({
        selector: ".js-print",
        hideSelector: ".js-print-hide",
        addPageBreaks: false,
        desktopViewportWidth: 930
    });

    // ---------------------------------
    // Filter initialisieren
    // ---------------------------------

    // Dropdowns initialisieren, sobald Filter vorhanden sind
    if (hasFilters) {
        initDropdowns();
    }

    // Filterlogik nur aktivieren, wenn alle benötigten Bereiche existieren
    if (hasFilters && hasItems && hasActiveFilters) {
        initFilters();
    }

    /*
    // Optionaler Sonderfall mit Reset-Button:
    const hasReset = document.getElementById("reset-filters");
    if (hasFilters && hasItems && hasActiveFilters && hasReset) {
        initFilters();
    }
    */

    // ---------------------------------
    // Jumpmarks initialisieren
    // ---------------------------------
    let offsetTopJumpmarks = 0;

    // Sticky-Header-Höhe berücksichtigen
    if (stickyHeaderArea) {
        offsetTopJumpmarks = stickyHeaderArea.clientHeight;
    }

    // Optionalen globalen Offset addieren
    if (typeof GLOBALS !== "undefined" && GLOBALS.offsetTopJumpmarks) {
        offsetTopJumpmarks += GLOBALS.offsetTopJumpmarks;
    }

    initJumpmarks(offsetTopJumpmarks);

    document.querySelectorAll(".js-hide-license-expired").forEach(function (button) {
        button.addEventListener("click", function () {
            setLicenseExpiresSoonCookie();
        });
    });

    const video = document.querySelector('#modalManual video');

    document.querySelectorAll('.modal__close, .modal').forEach(el => {
        el.addEventListener('click', () => {
            video.pause();
        });
    });

    sortItems("swiper-wrapper", "swiper-slide", "popular", "sort-popular");

    initSortSelectWeekly();

    sortItemsByUrl();

    initIntro();

    /*document.addEventListener("click", function (e) {
        if (e.target.closest(".js-keycloakLogout")) {
            resetIntro();
        }
    });*/

    applySortingToGroupItems().then(n => console.log(`${n} Items gesetzt`));
});